"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionAtPoint = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const AnchorPointHandle_1 = require("./AnchorPointHandle");
const context_1 = require("./context");
const PositionPopup_1 = require("./PositionPopup");
const PositionAtPoint = ({ point, animate, fadeIn, children }) => {
    const handle = React.useMemo(() => AnchorPointHandle_1.AnchorPointHandle.fromPoint(point), [point]);
    return (React.createElement(context_1.anchorContext.Provider, { value: handle },
        React.createElement(PositionPopup_1.PositionPopup, { animate: animate, fadeIn: fadeIn }, children)));
};
exports.PositionAtPoint = PositionAtPoint;
